import { IconButton, SvgIcon } from "@mui/material";
import * as Sentry from "@sentry/react";
import { getSessionUser, signOutSession } from "../auth/session";
import { getAuthProvider } from "../config/product";
import { SignOut, withAmazon } from "aws-amplify-react";
import cookie from "cookie";

import { axios } from "../api";
import { navCacheId } from "./navRequest";
import { getCognitoConfig } from "../config/product";
import { topBarIconButtonSx, topBarIconSx } from "../components/dropdownMenuStyles";

function LogoutIcon(props) {
  // https://material.io/resources/icons/?icon=logout&style=outline
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <path d="M17,8l-1.41,1.41L17.17,11H9v2h8.17l-1.58,1.58L17,16l4-4L17,8z M5,5h7V3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h7v-2H5V5z" />
      </g>
    </SvgIcon>
  );
}

class CustomSignOut extends SignOut {
  signOut = async () => {
    try {
      const options = {
        expires: new Date(1970, 1, 1, 0, 0, 1),
        maxAge: -1,
        path: "/",
        domain: window.location.hostname,
      };
      document.cookie = cookie.serialize("WebHavenUserID", "", options);
      document.cookie = cookie.serialize("ModuleSessionID", "", options);
      document.cookie = cookie.serialize("RoxenHttpsWizardId", "", options);
      document.cookie = cookie.serialize("RoxenWizardId", "", options);

      if (typeof localStorage !== "undefined") {
        localStorage.clear();
      }
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.clear();
      }

      // Safe cache cleanup
      try {
        axios.storage?.remove?.("get-current-user");
        const user: any = await getSessionUser().catch(() => null);
        if (user?.attributes?.["custom:aeronet_user_id"]) {
          axios.storage?.remove?.(
            navCacheId(user.attributes["custom:aeronet_user_id"])
          );
        }
      } catch (e) {
        console.debug("Cache cleanup error during signout", e);
      }

      Sentry.configureScope((scope) => scope.setUser(null));

      await signOutSession().catch(() => {});

      if (getAuthProvider() === "gcip") {
        window.location.href = "/app/";
        return;
      }

      // Redirect to Cognito hosted UI logout endpoint
      try {
        const cognito = getCognitoConfig();
        const cognitoDomain = cognito.domain;
        const clientId = cognito.userPoolWebClientId;
        const logoutUri = encodeURIComponent(
          cognito.redirectSignOut || window.location.origin
        );
        window.location.href = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;
      } catch {
        window.location.href = "/app/";
      }
    } catch (err) {
      console.error("SignOut error", err);
      window.location.href = "/app/";
    }
  };

  render() {
    // Same shared top-bar sizing as the notification and help icons —
    // dropdownMenuStyles' comment names logout as one of the three.
    return (
      <IconButton
        aria-label="sign out"
        color="inherit"
        onClick={this.signOut}
        edge="end"
        sx={topBarIconButtonSx}
      >
        <LogoutIcon sx={topBarIconSx} />
      </IconButton>
    );
  }
}

export default withAmazon(CustomSignOut);
